import { render, staticRenderFns } from "./data-dict-finder.vue?vue&type=template&id=1b9c74fd"
import script from "./data-dict-finder.vue?vue&type=script&lang=js"
export * from "./data-dict-finder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports